import { BlockType } from './../factory/BlockType';

/**
 * A node of a State tree. The state tree represents the user program as precompiled by the precompiler
 * from the diagram schema. A tree made of these nodes is then passed to the compiler to assemble
 * the assemblyBlocks.
 */
export class StateNode {
    nodeId: string;
    children: StateNode[][];
    blockType: BlockType;
    constInputs: any[];
    hasBeenCompiled: boolean;
    isInput: boolean;
    isTriggered: boolean;

    /**
     * Constructor.
     * @param nodeId the id of the corresponding node in diagram schema
     * @param blockType the type of the corresponding AssemblyBlock
     * @param constInputs constant (static) inputs needed conr constructing AssemblyBloc
     * @param isInput true iff this is an input node (without children)
     */
    constructor(nodeId: string, blockType: BlockType, constInputs: any[], isInput: boolean) {
        this.nodeId = nodeId;
        this.blockType = blockType;
        this.children = [];
        this.hasBeenCompiled = false;
        this.isInput = isInput;
        this.constInputs = constInputs;

        // todo this needs to be updated when more triggered blocks are added
        this.isTriggered = blockType === BlockType.BTN_STATUS ||
            blockType === BlockType.JOY_X ||
            blockType === BlockType.JOY_Y;
    }
}